import { render, staticRenderFns } from "./menu-button.svg.vue?vue&type=template&id=d01a8712&"
import script from "./menu-button.svg.vue?vue&type=script&lang=js&"
export * from "./menu-button.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports